<div class="search-wrapper m-0">
  <div class="autocomplete-wrapper m-auto d-flex align-items-center">
    @if (!autocompleteNgram) {
      <div class="input-group">
        <div class="d-none" id="esearch-input-describedby-{{key}}">{{ariaDescribedby}}</div>
        <input type="text"
          id = "{{idInputToFous}}"
          class="form-control h-auto"
          placeholder="{{placeholderInput|translate}}"
          attr.aria-label="{{placeholderInput|translate}}"
          [attr.aria-describedby]="'esearch-input-describedby-' + key"
          [formControl]="searchSectionsCtrl"
          #searchVal
          (keydown)="handleKeydown($event)"
          (keydown.enter)="search(); searchVal.blur()"
          (keydown.escape)="isOpen = false"
          (focus)="onFocus()">
        @if (enableTaxonomySubjectSearch) {
          <taxonomy-menu [enableTaxonomySubjectSearch]="true" [key]="'subject-search'" [taxonomyTypeVar]="[taxonomySubjectSearchVar]" [displayMode]="'selectmenu'" [selectedOnMenu]="selectedOnMenuByName" [selectPanelClass]="'esearchTaxSubject'" (onChangeMenu)="onChangeMenuSubjectSearch($event)"></taxonomy-menu>
        }
        <div class="input-group-append">
          <button (click)="search()" [class]="buttonClasses? buttonClasses : 'btn search-btn app-btn-search'" type="button" [attr.aria-label]="shouldAriaLabel ?  ('Submit Search'|translate) : null">
            <!--button content from entity-->
            <div #btnContent [ngClass]="{'d-none':btnContent.childElementCount === undefined || btnContent.childElementCount === 0}">
              <ng-content select=".button-content"></ng-content>
            </div>
            <!--/button content from entity-->
            <!--fallback button content-->
            @if (btnContent.childElementCount === undefined || btnContent.childElementCount === 0) {
              <i class="fa fa-search"></i>
            }
          </button>
        </div>
      </div>
      @if (enableExactMatch) {
        <div class="mx-3">
          <mat-checkbox (change)="onExactMatchChange($event)">
            {{'Exact Match' | translate}}
          </mat-checkbox>
        </div>
      }
      @if (!autocompleteNgram) {
        <div>
          @if (isOpen) {
            <div class="autocomplete-results-wrapper w-50">
              @if (searchList.length) {
                <div class="results-table-wrapper">
                  @if (listTitle) {
                    <h6 class="search-list-title">{{listTitle}}</h6>
                  }
                  @if (searchPageData.pageMode != 'dictionary') {
                    <ul class="p-0 m-0">
                      @for (item of searchList; track item; let index = $index; let first = $first; let last = $last) {
                        <li class="m-3 ml-auto ng-star-inserted p-3 row item-num-{{index}}"  >
                          @if ((templates$|async) && searchPageData.autocomplete?.['previewTemplateVar']) {
                            <span  (keydown)="keyBoardFunc($event, index, first, last)">
                              <div [innerHtml]="(templates$|async)[searchPageData.autocomplete['previewTemplateVar']]| replaceTokensArray: {keys: item, previewVar: searchPageData.autocomplete['previewTemplateVar']} | safe: 'html'"></div>
                            </span>
                          } @else {
                            <a [routerLink]="item.preview_link_s" (click)="isOpen = false"  (keydown)="keyBoardFunc($event, index, first, last)">
                              @if (searchPageData.autocomplete['displayField'].title && item[searchPageData.autocomplete['displayField'].title.field]) {
                                <div
                                  [ngStyle]="{color: searchPageData.autocomplete['displayField'].title.color}" >
                                  {{item[searchPageData.autocomplete['displayField'].title.field]}}
                                </div>
                              }
                              @if (searchPageData.autocomplete['displayField'].head && item[searchPageData.autocomplete['displayField'].head.field]) {
                                <h5
                                  [ngStyle]="{color: searchPageData.autocomplete['displayField'].head.color}" >
                                  {{item[searchPageData.autocomplete['displayField'].head.field]}}
                                </h5>
                              }
                              @if (searchPageData.autocomplete['displayField'].summery && item[searchPageData.autocomplete['displayField'].summery.field]) {
                                <div
                                  [ngStyle]="{color: searchPageData.autocomplete['displayField'].summery.color}" >
                                  {{item[searchPageData.autocomplete['displayField'].summery.field]}}
                                </div>
                              }
                            </a>
                          }
                        </li>
                      }
                    </ul>
                  }
                  @if (searchPageData.pageMode == 'dictionary') {
                    <ul  class="p-0 m-0" >
                      @for (item of searchList; track item; let index = $index; let first = $first; let last = $last) {
                        <li class="m-3 ml-auto ng-star-inserted p-3 row item-num-{{index}}" >
                          <a  (click)="createDictionarySearch(item)"   (keydown)="keyBoardFunc($event, index, first, last)">
                            @if (searchPageData.autocomplete['displayField'].title && item[searchPageData.autocomplete['displayField'].title.field]) {
                              <div
                                [ngStyle]="{color: searchPageData.autocomplete['displayField'].title.color}" >
                                {{item[searchPageData.autocomplete['displayField'].title.field]}}
                              </div>
                            }
                            @if (searchPageData.autocomplete['displayField'].head && item[searchPageData.autocomplete['displayField'].head.field]) {
                              <h5
                                [ngStyle]="{color: searchPageData.autocomplete['displayField'].head.color}" >
                                {{item[searchPageData.autocomplete['displayField'].head.field]}}
                              </h5>
                            }
                            @if (searchPageData.autocomplete['displayField'].summery && item[searchPageData.autocomplete['displayField'].summery.field]) {
                              <div
                                [ngStyle]="{color: searchPageData.autocomplete['displayField'].summery.color}" >
                                {{item[searchPageData.autocomplete['displayField'].summery.field]}}
                              </div>
                            }
                          </a>
                        </li>
                      }
                    </ul>
                  }
                </div>
              } @else {
                @if (autocompleteNoResultsBlockVar) {
                  <entity-block [entityVar]="autocompleteNoResultsBlockVar"></entity-block>
                }
              }
            </div>
          }
        </div>
      } @else {
        <div>
          <div class="input-group" [class.input-group-is-open]="isOpen && results.length">
            <input type="text"
              id = "{{idInputToFous}}"
              class="form-control h-auto"
              placeholder="{{searchPlaceholder|translate}}"
              attr.aria-label="{{searchPlaceholder|translate}}"
              [formControl]="searchSectionsCtrl"
              #searchVal
              (keydown.enter)="search(); searchVal.blur()"
              (keydown.escape)="isOpen = false"
              (focus)="onFocus()">
            @if (enableTaxonomySubjectSearch) {
              <taxonomy-menu [enableTaxonomySubjectSearch]="true" [key]="'subject-search'" [taxonomyTypeVar]="[taxonomySubjectSearchVar]" [displayMode]="'selectmenu'"  [selectedOnMenu]="selectedOnMenuByName" [selectPanelClass]="'esearchTaxSubject'" (onChangeMenu)="onChangeMenuSubjectSearch($event)"></taxonomy-menu>
            }
            <div class="input-group-append">
              <button (click)="search()" class="btn search-btn app-btn-search" [ngClass]="{'isOpen': key?.length > 0 && shareSvc.isMobileMode()}" type="button" attr.aria-label="{{'Submit Search'|translate}}">
                <div #btnContent [ngClass]="{'d-none':btnContent.childElementCount === undefined || btnContent.childElementCount === 0}">
                  <ng-content select=".button-content-search"></ng-content>
                </div>
                @if (btnContent.childElementCount === undefined || btnContent.childElementCount === 0) {
                  <i class="fa fa-search"></i>
                }
              </button>
            </div>
          </div>
          <div class="autocomplete-wrapper">
            @if (isOpen) {
              <div class="autocomplete-results-wrapper">
                @if (results.length) {
                  <div class="results-table-wrapper">
                    <div class="results-table" [ngClass]="{'d-lg-table': results.length > 2 && splitRow}">
                        <ng-template ngFor [ngForOf]="results" let-index="index">
                        @if (index % 2 === 0) {
                          <div class="grouped-results-group" [ngClass]="{'d-lg-table-cell': results.length > 2 && splitRow}">
                            <div class="results-group container-fluid" [ngClass]="{'products-results': results[index]['type'] === 'products'}">
                              @if (results[index].type === 'ShowAllResults') {
                                <h5 translate class="show-all-results" (click)="setKey(searchVal.value)">{{results[index].title}}</h5>
                              }
                              @if (results[index].type !== 'ShowAllResults') {
                                <h5 translate>{{results[index].title}}</h5>
                              }
                              <ul>
                                @for (item of results[index].items; track item) {
                                  <li class="row">
                                    @if ((templates$|async) && results[index].previewTemplateVar) {
                                      <div class="col-12" (click)="optionSelectedFunc(results[index], item)" (focusout)="onFocusOut(item)">
                                        <div [innerHtml]="(templates$|async)[results[index].previewTemplateVar]| replaceTokensArray: {keys: item, previewVar: results[index].previewTemplateVar} | safe: 'html'"></div>
                                      </div>
                                    }
                                    @if (!results[index].previewTemplateVar) {
                                      @if (results[index]['imageDisplay'] || item['image_path']) {
                                        <div class="col-auto">
                                          @if (results[index]['imageDisplay']) {
                                            <img product-image
                                              [product]="item"
                                              [size]="'Sma'"
                                              class="card-img-top img-responsive"
                                              >
                                          }
                                          <!-- for custom search item image-->
                                          @if (item['image_path']) {
                                            <img
                                              [src]="restUrlsConf.beURL  + item['image_path']"
                                              class="card-img-top img-responsive"
                                              >
                                          }
                                        </div>
                                      }
                                      <button class="col result-item" (click)="optionSelectedFunc(results[index], item)" (focusout)="onFocusOut(item)">
                                        @if (!results[index]['displayFieldPattern']) {
                                          <span class="p-name">{{item[results[index]['displayField']]}}</span>
                                        }
                                        @if (results[index]['displayFieldPattern']) {
                                          <span class="p-name" data-pattern [data]="item" [pattern]="results[index]['displayFieldPattern']"></span>
                                        }
                                        @if (item[results[index]['displayFieldDesc']]) {
                                          <span class="p-desc">{{item[results[index]['displayFieldDesc']]}}</span>
                                        }
                                      </button>
                                    }
                                  </li>
                                }
                              </ul>
                            </div>
                            @if (results[index + 1]) {
                              <div class="results-group 2222 container-fluid" [ngClass]="{'products-results': results[index + 1]['type'] === 'products'}">
                                @if (results[index + 1].type === 'ShowAllResults') {
                                  <h5 translate class="show-all-results" (click)="setKey(searchVal.value)">{{results[index + 1].title}}</h5>
                                }
                                @if (results[index + 1].type !== 'ShowAllResults') {
                                  <h5 translate>{{results[index + 1].title}}</h5>
                                }
                                <ul>
                                  @for (item of results[index + 1].items; track item) {
                                    <li class="row">
                                      @if ((templates$|async) && results[index + 1].previewTemplateVar) {
                                        <div class="col-12" (click)="optionSelectedFunc(results[index + 1], item)" (focusout)="onFocusOut(item)">
                                          <div [innerHtml]="(templates$|async)[results[index + 1].previewTemplateVar]| replaceTokensArray: {keys: item, previewVar: results[index + 1].previewTemplateVar} | safe: 'html'"></div>
                                        </div>
                                      }
                                      @if (!results[index + 1].previewTemplateVar) {
                                        @if (results[index + 1]['imageDisplay']) {
                                          <div class="col-auto">
                                            <img product-image
                                              [product]="item"
                                              [size]="'Sma'"
                                              class="card-img-top img-responsive">
                                          </div>
                                        }
                                        <button class="col result-item" (click)="optionSelectedFunc(results[index + 1], item)" (focusout)="onFocusOut(item)">
                                          @if (!results[index + 1]['displayFieldPattern']) {
                                            <span class="p-name">{{item[results[index + 1]['displayField']]}}</span>
                                          }
                                          @if (results[index + 1]['displayFieldPattern']) {
                                            <span class="p-name" data-pattern [data]="item" [pattern]="results[index + 1]['displayFieldPattern']"></span>
                                          }
                                          @if (item[results[index + 1]['displayFieldDesc']]) {
                                            <span class="p-desc">{{item[results[index + 1]['displayFieldDesc']]}}</span>
                                          }
                                        </button>
                                      }
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </div>
                        }
                        </ng-template>

                      @if (results && key?.length > 0) {
                        <button class="close-btn-desktop p-{{positionClose}}"
                          (click)="isOpen = false; key = ''"
                          attr.aria-label="{{'Clear Search'|translate}}">
                          <i class="material-icons">close</i>
                        </button>
                      }
                    </div>
                  </div>
                } @else {
                  @if (autocompleteNoResultsBlockVar) {
                    <entity-block [entityVar]="autocompleteNoResultsBlockVar"></entity-block>
                  }
                }
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div>
        <div class="input-group" [class.input-group-is-open]="isOpen && results.length">
          <input type="text"
            id = "{{idInputToFous}}"
            class="form-control h-auto"
            placeholder="{{searchPlaceholder|translate}}"
            attr.aria-label="{{searchPlaceholder|translate}}"
            [formControl]="searchSectionsCtrl"
            #searchVal
            (keydown.enter)="search(); searchVal.blur()"
            (keydown.escape)="isOpen = false"
            (focus)="onFocus()">
          @if (enableTaxonomySubjectSearch) {
            <taxonomy-menu [enableTaxonomySubjectSearch]="true" [key]="'subject-search'" [taxonomyTypeVar]="[taxonomySubjectSearchVar]" [displayMode]="'selectmenu'"  [selectedOnMenu]="selectedOnMenuByName" [selectPanelClass]="'esearchTaxSubject'" (onChangeMenu)="onChangeMenuSubjectSearch($event)"></taxonomy-menu>
          }
          <div class="input-group-append">
            <button (click)="search()" class="btn search-btn app-btn-search" [ngClass]="{'isOpen': key?.length > 0 && shareSvc.isMobileMode()}" type="button" attr.aria-label="{{'Submit Search'|translate}}">
              <div #btnContent [ngClass]="{'d-none':btnContent.childElementCount === undefined || btnContent.childElementCount === 0}">
                <ng-content select=".button-content-search"></ng-content>
              </div>
              @if (btnContent.childElementCount === undefined || btnContent.childElementCount === 0) {
                <i class="fa fa-search"></i>
              }
            </button>
          </div>
        </div>
        <div class="autocomplete-wrapper">
          @if (isOpen) {
            <div class="autocomplete-results-wrapper">
              @if (results.length) {
                <div class="results-table-wrapper">
                  <div class="results-table" [ngClass]="{'d-lg-table': results.length > 2 && splitRow}">
                      <ng-template ngFor [ngForOf]="results" let-index="index">
                      @if (index % 2 === 0) {
                        <div class="grouped-results-group" [ngClass]="{'d-lg-table-cell': results.length > 2 && splitRow}">
                          <div class="results-group container-fluid" [ngClass]="{'products-results': results[index]['type'] === 'products'}">
                            @if (results[index].type === 'ShowAllResults') {
                              <h5 translate class="show-all-results" (click)="setKey(searchVal.value)">{{results[index].title}}</h5>
                            }
                            @if (results[index].type !== 'ShowAllResults') {
                              <h5 translate>{{results[index].title}}</h5>
                            }
                            <ul>
                              @for (item of results[index].items; track item) {
                                <li class="row">
                                  @if ((templates$|async) && results[index].previewTemplateVar) {
                                    <div class="col-12" (click)="optionSelectedFunc(results[index], item)" (focusout)="onFocusOut(item)">
                                      <div [innerHtml]="(templates$|async)[results[index].previewTemplateVar]| replaceTokensArray: {keys: item, previewVar: results[index].previewTemplateVar} | safe: 'html'"></div>
                                    </div>
                                  }
                                  @if (!results[index].previewTemplateVar) {
                                    @if (results[index]['imageDisplay'] || item['image_path']) {
                                      <div class="col-auto">
                                        @if (results[index]['imageDisplay']) {
                                          <img product-image
                                            [product]="item"
                                            [size]="'Sma'"
                                            class="card-img-top img-responsive"
                                            >
                                        }
                                        <!-- for custom search item image-->
                                        @if (item['image_path']) {
                                          <img
                                            [src]="restUrlsConf.beURL  + item['image_path']"
                                            class="card-img-top img-responsive"
                                            >
                                        }
                                      </div>
                                    }
                                    <button class="col result-item" (click)="optionSelectedFunc(results[index], item)" (focusout)="onFocusOut(item)">
                                      @if (!results[index]['displayFieldPattern']) {
                                        <span class="p-name">{{item[results[index]['displayField']]}}</span>
                                      }
                                      @if (results[index]['displayFieldPattern']) {
                                        <span class="p-name" data-pattern [data]="item" [pattern]="results[index]['displayFieldPattern']"></span>
                                      }
                                      @if (item[results[index]['displayFieldDesc']]) {
                                        <span class="p-desc">{{item[results[index]['displayFieldDesc']]}}</span>
                                      }
                                    </button>
                                  }
                                </li>
                              }
                            </ul>
                          </div>
                          @if (results[index + 1]) {
                            <div class="results-group 2222 container-fluid" [ngClass]="{'products-results': results[index + 1]['type'] === 'products'}">
                              @if (results[index + 1].type === 'ShowAllResults') {
                                <h5 translate class="show-all-results" (click)="setKey(searchVal.value)">{{results[index + 1].title}}</h5>
                              }
                              @if (results[index + 1].type !== 'ShowAllResults') {
                                <h5 translate>{{results[index + 1].title}}</h5>
                              }
                              <ul>
                                @for (item of results[index + 1].items; track item) {
                                  <li class="row">
                                    @if ((templates$|async) && results[index + 1].previewTemplateVar) {
                                      <div class="col-12" (click)="optionSelectedFunc(results[index + 1], item)" (focusout)="onFocusOut(item)">
                                        <div [innerHtml]="(templates$|async)[results[index + 1].previewTemplateVar]| replaceTokensArray: {keys: item, previewVar: results[index + 1].previewTemplateVar} | safe: 'html'"></div>
                                      </div>
                                    }
                                    @if (!results[index + 1].previewTemplateVar) {
                                      @if (results[index + 1]['imageDisplay']) {
                                        <div class="col-auto">
                                          <img product-image
                                            [product]="item"
                                            [size]="'Sma'"
                                            class="card-img-top img-responsive">
                                        </div>
                                      }
                                      <button class="col result-item" (click)="optionSelectedFunc(results[index + 1], item)" (focusout)="onFocusOut(item)">
                                        @if (!results[index + 1]['displayFieldPattern']) {
                                          <span class="p-name">{{item[results[index + 1]['displayField']]}}</span>
                                        }
                                        @if (results[index + 1]['displayFieldPattern']) {
                                          <span class="p-name" data-pattern [data]="item" [pattern]="results[index + 1]['displayFieldPattern']"></span>
                                        }
                                        @if (item[results[index + 1]['displayFieldDesc']]) {
                                          <span class="p-desc">{{item[results[index + 1]['displayFieldDesc']]}}</span>
                                        }
                                      </button>
                                    }
                                  </li>
                                }
                              </ul>
                            </div>
                          }
                        </div>
                      }
                    </ng-template>
                    @if (results && key?.length > 0) {
                      <button class="close-btn-desktop p-{{positionClose}}"
                        (click)="isOpen = false; key = ''"
                        attr.aria-label="{{'Clear Search'|translate}}">
                        <i class="material-icons">close</i>
                      </button>
                    }
                  </div>
                </div>
              } @else {
                @if (autocompleteNoResultsBlockVar) {
                  <entity-block [entityVar]="autocompleteNoResultsBlockVar"></entity-block>
                }
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>



